import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const SignInPage1 = ({ msg, history, setSignPageNo, setChooseOption }: any) => {

    let [termsPopupActive, setTermsPopupActive] = useState<boolean>(false);

    const allCheck = (e: any) => {

        if ((e.code === 'Space' || e.code === 'Enter') || e.type === "click") {

            if ((e.code === 'Space' || e.code === 'Enter')) {
                const allCheckBox: any = document.querySelector('#checkbox-all');
                allCheckBox.checked = !allCheckBox.checked;
            }
            const checkBoxList: any = document.querySelectorAll('.check-detail-div input[type=checkbox]');

            for (const checkBoxItem of checkBoxList) {
                if (checkBoxItem['id'] !== 'allCheck') {
                    checkBoxItem.checked = e.target.checked;
                }
            }
        }
    }

    const onKeyUpHandler = (e: any) => {

        if ((e.code === 'Space' || e.code === 'Enter')) {
            const checkBoxItem: any = document.querySelector('#' + e.target.id);
            checkBoxItem.checked = !checkBoxItem.checked;
        }
    }

    const onClickNext = () => {
        // todo
        const checkList: any = document.querySelectorAll('.check-detail-div input[type=checkbox].req');

        for (const checkItem of checkList) {
            if (checkItem['checked'] === false) {
                alert(msg['essentialMsg']);
                return;
            }
        }

        const chooseOptionEle: any = document.querySelector('#checkbox-2');
        setChooseOption(chooseOptionEle['checked']);

        setSignPageNo(2);
    }

    return (
        <>
            <div className={"modal fade" + (termsPopupActive ? ' show' : '')}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <strong className="modal-title" id="staticBackdropLabel">한국은행 경제통계시스템 개인정보 수집이용 동의</strong>
                            <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setTermsPopupActive(false) }}>
                            </button>
                        </div>
                        <div className="modal-body set-height">
                            <div className="modal-comp">
                                <div className="txt-con">
                                    <div className="con-tit">
                                        <strong className="tit">경제통계시스템 회원 관리 및 게시글 관리를 위한 개인정보 수집·이용 동의서</strong>
                                    </div>
                                    <div className="con-desc">
                                        <p><span style={{ fontSize: "10pt" }}>  한국은행은 다음의 목적을 위하여 「개인정보 보호법」 제15조 및 제22조에 따라 아래와 같이 개인정보를 수집·이용하고자 합니다. 내용을 읽어 보신 후 동의 여부를 결정하여 주십시오. </span></p>
                                        <p><br /></p>
                                        <p>■ 개인정보 수집·이용 목적</p>
                                        <p><br /></p>
                                        <p>가. 회원 관리 : 회원제 서비스 이용, 회원 정보 관리, 분쟁 조정을 위한 기록보존, 공지사항 전달</p>
                                        <p>나. 게시글 관리 : Q&A 게시판 질의응답, 원활한 민원처리</p>
                                        <p>다. 기타 : 본인확인, 개인식별, 부정이용 방지, 비인가 사용 방지, 홈페이지 개선의견 수집, 접속빈도 파악,</p>
                                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;서비스 이용에 대한 통계 수집의 목적으로 개인정보를 처리합니다.</p>
                                        <p><br /></p>
                                        <p>■ 필수정보 수집·이용 내역</p>
                                        <p><br /></p>
                                        <table cellSpacing="0" cellPadding="0" border={1} style={{ width: "100%", height: "97px", fontSize: "10pt", borderWidth: "0px", borderColor: "rgb(0, 0, 0)", borderCollapse: "collapse", borderStyle: "solid", backgroundColor: "rgb(255, 255, 255)" }}><tbody>
                                            <tr>
                                                <th style={{ width: "20%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                                                    <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>수집·이용 목적</span></span></p>
                                                </th>
                                                <th style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                                                    <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>수집·이용 항목</span></span></p>
                                                </th>
                                                <th style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                                                    <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>보유·이용 기간</span></span></p>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "8%", height: "48px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                                                    <p style={{ lineHeight: "100%" }}><span style={{ fontSize: "10pt" }}>&nbsp;&nbsp;회원 관리</span></p></td>
                                                <td style={{ width: "55%", height: "48px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                                                    <p style={{ lineHeight: "100%" }}><span style={{ fontSize: "10pt" }}>&nbsp;&nbsp;아이디, 이름, 이메일, 패스워드, 법정대리인 이름(만14세 미만 이용자인 경우)</span></p></td>
                                                <td style={{ width: "37%", height: "48px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                                                    <p style={{ lineHeight: "100%", fontWeight: "bold", fontSize: "larger" }}>&nbsp;&nbsp;수집일로부터 2년</p></td>
                                            </tr>
                                        </tbody></table>
                                        <p><br /></p>
                                        <p>※ 귀하는 위 개인정보 수집·이용에 동의하지 않을 권리가 있습니다. 그러나 동의를 거부할 경우 회원 가입 또는 게시글 작성이 불가합니다.</p>
                                        <p><br /></p>
                                        <p>■ 선택정보 수집·이용 내역</p>
                                        <p><br /></p>
                                        <table cellSpacing="0" cellPadding="0" border={1} style={{ width: "100%", height: "97px", fontSize: "10pt", borderWidth: "0px", borderColor: "rgb(0, 0, 0)", borderCollapse: "collapse", borderStyle: "solid", backgroundColor: "rgb(255, 255, 255)" }}><tbody>
                                            <tr>
                                                <th style={{ width: "20%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                                                    <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>수집·이용 목적</span></span></p>
                                                </th>
                                                <th style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                                                    <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>수집·이용 항목</span></span></p>
                                                </th>
                                                <th style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                                                    <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>보유·이용 기간</span></span></p>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "20%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                                                    <p style={{ lineHeight: "100%" }}><span style={{ fontSize: "10pt" }}>&nbsp;&nbsp;회원 관리</span></p></td>
                                                <td style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                                                    <p style={{ lineHeight: "100%" }}><span style={{ fontSize: "10pt" }}>&nbsp;&nbsp;직업</span></p></td>
                                                <td style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                                                    <p style={{ lineHeight: "100%", fontWeight: "bold", fontSize: "larger" }}>&nbsp;&nbsp;수집일로부터 2년</p></td>
                                            </tr>
                                        </tbody></table>
                                        <p><br /></p>
                                        <p>※ 귀하는 선택정보 수집·이용에 동의하지 않을 권리가 있으며 동의를 거부할 경우에도 회원 가입이 가능합니다.</p>
                                        <p><br /></p>
                                        <p>2. 기타 고지사항</p>
                                        <p>  인터넷 서비스 이용과정에서 IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등의 개인정보 항목이 자동으로 생성되어 수집될 수 있으며, 이는 홈페이지 개선과 보안대책 수립 등의 목적으로 이용될 수 있습니다.</p>
                                        <p><br /></p>
                                        <p>※ 개인정보 처리에 관한 자세한 사항은 한국은행 홈페이지(http://www.bok.or.kr)의 “개인정보처리방침”을 참고하시기 바랍니다.</p>
                                    </div>
                                    <div className="btn-wrap">
                                        <button type="button" className="btn btn-popup positive" onClick={() => { setTermsPopupActive(false) }}>확인</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal-backdrop fade" + (termsPopupActive ? ' show' : '')}></div>
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="join-step">
                    <div className="join-step-head">
                        <div className="left">
                            <h2>회원가입</h2>
                        </div>
                        <div className="right">
                            <div className="step-status">
                                <h3></h3>
                                <ul className="clearfix">
                                    <li className="step-li active"><span className="num">1</span> <span className="step-txt">약관동의</span></li>
                                    <li className="step-li"><span className="num">2</span> <span className="step-txt">정보입력</span></li>
                                    <li className="step-li"><span className="num">3</span> <span className="step-txt">회원가입 완료</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="join-step-body">
                        <div>
                            <fieldset>
                                <div className="check-all-div">
                                    <div className="form-group form-group-checkbox">
                                        <div className="input-box-group">
                                            <div className="input-box">
                                                <div className="input-group">
                                                    <input type="checkbox" id="checkbox-all" className="form-control form-control-sm" onKeyUp={allCheck} onClick={allCheck} />
                                                    <label htmlFor="checkbox-all" className="label-checkbox-all" ><span className="line-height: 1;">전체 동의</span></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="check-detail-div">
                                    <div className="form-group form-group-checkbox">
                                        <div className="input-box-group">
                                            <div className="input-box input-box-btn">
                                                <div className="input-group">
                                                    <input type="checkbox" id="checkbox-1" className="form-control form-control-sm req" onKeyUp={(e) => onKeyUpHandler(e)} />
                                                    <label htmlFor="checkbox-1"><span>개인정보 수집이용 동의 <strong className="text-important">(필수)</strong></span></label>
                                                    <button type="button" className="btn btn-show-terms" onClick={() => setTermsPopupActive(true)}>보기</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group form-group-checkbox">
                                        <div className="input-box-group">
                                            <div className="input-box input-box-btn">
                                                <div className="input-group">
                                                    <input type="checkbox" id="checkbox-2" className="form-control form-control-sm" onKeyUp={(e) => onKeyUpHandler(e)} />
                                                    <label htmlFor="checkbox-2"><span>직업 정보제공에 동의합니다. (선택)</span></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <ul className="join-step-p">
                                <li className="join-step-dot">회원가입을 위해 최초 회원가입 시 아래와 같은 개인정보를 수집하고 있습니다.</li>
                                <li className="join-step-dot">수집한 개인정보는 회원자격 유지기간 동안 보관합니다.</li>
                                <li className="join-step-dot">회원께서는 개인정보 수집 동의를 거부하실 수 있으며, 다만 필수항목수집을 거부하실 경우 회원가입이 제한됩니다.</li>
                            </ul>
                        </div>
                        <div className="btn-group btn-130">
                            <button type="button" className="btn btn-popup negative" title="약관동의를 취소합니다." onClick={() => history.push('/Login')}>취소</button>
                            <button type="button" className="btn btn-popup positive" title="정보입력 페이지로 이동합니다." onClick={onClickNext}>다음</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default SignInPage1;